import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Mail, Image as ImageIcon, QrCode, Users, Linkedin, Globe } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide14Channels({
  index
}: SlideProps) {
  const channels = [{
    icon: MessageCircle,
    label: 'WhatsApp',
    pos: 'top-0 left-1/2 -translate-x-1/2 -translate-y-1/2'
  }, {
    icon: Mail,
    label: 'Email',
    pos: 'top-[15%] right-[15%] translate-x-1/2 -translate-y-1/2'
  }, {
    icon: ImageIcon,
    label: 'Banner',
    pos: 'top-1/2 right-0 translate-x-1/2 -translate-y-1/2'
  }, {
    icon: QrCode,
    label: 'Congress QR',
    pos: 'bottom-[15%] right-[15%] translate-x-1/2 translate-y-1/2'
  }, {
    icon: Users,
    label: 'Rep follow-up',
    pos: 'bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2'
  }, {
    icon: Linkedin,
    label: 'LinkedIn',
    pos: 'bottom-[15%] left-[15%] -translate-x-1/2 translate-y-1/2'
  }, {
    icon: Globe,
    label: 'Website',
    pos: 'top-1/2 left-0 -translate-x-1/2 -translate-y-1/2'
  }, {
    icon: Globe,
    label: 'Landing page',
    pos: 'top-[15%] left-[15%] -translate-x-1/2 -translate-y-1/2'
  }];
  return <InteriorSlide surface data-id="element-316" data-mp="2s9lewhjbczv7">
      <SlideHeader eyebrow="Channel-Agnostic Deployment" data-id="element-317" data-mp="2o65ow41r1xrh">
        One campaign experience, multiple digital entry points
      </SlideHeader>

      <div className="flex-1 flex flex-col items-center justify-start max-w-5xl mx-auto w-full min-h-0" data-id="element-318" data-mp="2jdcf31rfbz8j">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed mb-8 text-center max-w-3xl flex-shrink-0" data-id="element-319" data-mp="2eg3wx169zv7a">
          The same Snakker campaign can be deployed across channels, making the
          content more efficient and the HCP experience more consistent.
        </motion.p>

        <div className="w-full flex-1 min-h-0 flex items-center justify-center pb-4" data-id="element-320" data-mp="1gvku91xku0qf">
          <img src="https://cdn.magicpatterns.com/uploads/pDNxXsk1dDvR7wMENefzcq/Screenshot_2026-06-29_at_13.20.38.png" alt="Channel-Agnostic Deployment Channels" className="w-full max-w-4xl max-h-full rounded-2xl shadow-sm border border-black/5 object-contain" data-id="element-321" data-mp="1ludxm1j5gbcv" />
        </div>
      </div>
    </InteriorSlide>;
}